export const config = {
  api: {
    endpoint: "https://api.livemeetings.mx",
    endpointUpload: "https://upload.ovp.support",
    endpointServerless: "https://serverless.ovp.support",
    endpointAWS: "https://d0upje2y8f.execute-api.us-east-1.amazonaws.com",
    storage_service: "imcinestorage",
    videos_service: "imcinevideos",
    images_service: "imcineimages",
    metadata_service: "admin",
    base_service: "base",
    utils_service: "utils",
    events_service: "events",
    mix_service: "imcinemix",
    auth_service: "imcineauthentication",
    login: "login",
    sessionInfo: "sessioninfo",
    languages: "languages",
    qualities: "qualities",
    clasifications: "classifications",
    genres: "genres/organization",
    genders: "listGenders",
    moods: "moods",
    shortsAndFilms: "content/simple",
    movieShortDetail: "content",
    createMultipart: "newmultipart",
    closeMultipart: "completemultipartvideo",
    uploadVideo: "uploadmultipart",
    multipartStart: "utils/upload/multipart/start",
    multipartSignPart: "utils/upload/multipart/sign-part",
    multipartComplete: "utils/upload/multipart/complete",
    multipartTranscode: "utils/transcode",
    uploadimage: "content/images",
    createContent: "content/shorts",
    createMassiveContent: "content/shorts/masive",
    createMassiveMovieContent: "content/movies/masive",
    createGenre: "genres",
    createtag: "tags",
    updateContent: "content",
    updateTimeMark: "content/time-mark",
    updateClasifications: "content/classification",
    simplecontentlist: "content/simple",
    videosize: "videosize",
    hlsgenerator: "hlsgenerator",
    tagsByContent: "tags",
    linkImage: "content/images",
    listtags: "tags/organization",
    linkmoodtocontent: "moods/content",
    unlinkmoodtocontent: "moods/content",
    listgenrestocontent: "content/genres/by-content",
    linkgenretocontent: "content/genres",
    unlinkgenretocontent: "content/genres/by-content",
    linktagtocontent: "content/tags",
    unlinktagtocontent: "content/tags",
    listreleatedcontent: "related-content",
    addrelatedcontent: "content/related",
    removerelatedcontent: "content/related",
    listdistributors: "listdistributor/",
    listdistributorsOnContent: "listdistributoroncontent/",
    linkdistributor: "linkdistributor/",
    unlinkdistributor: "unlinkdistributor/",
    listactors: "actors/organization",
    listactorstocontent: "content/actors",
    linkactortocontent: "actors/content",
    unlinkactortocontent: "actors/content",
    listdirectors: "directors/organization",
    listdirectorstocontent: "content/directors",
    linkdirectortocontent: "content/directors",
    unlinkdirectortocontent: "content/directors",
    countries: "countries",
    createdirector: "directors",
    updatedirector: "directors",
    deletedirector: "directors",
    createactor: "actors",
    updateactor: "updateactor",
    listContentRights: "content/rights",
    addRightsToContent: "content/rights",
    deleteRightsToContent: "content/rights",
    updateRightsToContent: "content/rights",
    listContentRightDetail: "content/rights",
    searchmoviesandshorts: "search",
    deleteactor: "actors",
    createdistributor: "createdistributor",
    updatedistributor: "updatedistributor",
    deletedistributor: "deletedistributor",
    listdistributor: "listdistributor",
    listContentGeorestriction: "georestriction",
    addcontentgeorestriction: "georestriction",
    removecontentgeorestriction: "georestriction",
    listContentBlocks: "blocks/organization",
    createcontentblock: "blocks",
    updatecontentblock: "blocks",
    listblockelements: "home",
    linkcontentblock: "blocks",
    unlinkcontentblock: "blocks",
    deletecontentblock: "blocks",
    listMiniSites: "sites",
    MiniSiteDetail: "sites",
    linkContentBlockToMinisite: "sites/content",
    unlinkContentBlockToMinisite: "sites/content",
    deleteMiniSite: "sites",
    createMinisite: "sites",
    sortMinisiteContentBlocks: "sites/sort",
    updateMinisite: "sites",
    listsubtitles: "subtitles",
    removesubtitle: "removesubtitle",
    imcineattachments: "imcineattachments",
    uploadattachment: "uploadattachment",
    linkSubtitle: "linkSubtitle",
    royaltyreport: "royaltyreport",
    serieslist: "content/series",
    listContentMetadataSeasons: "content/series/seasons",
    deleteContentMetadataSeasons: "content/series/seasons",
    imcineusermanagementott: "imcineusermanagementott",
    listusers: "listusers",
    userDetail: "detail",
    suspendUser: "suspend",
    activateUser: "activate",
    closeSessions: "clear",
    userRecover: "recover",
    searchusers: "searchusers",
    payment_service: 'imcinepayment',
    listTrailers: 'content/previews',
    addTrailerToContent: 'content/previews',
    deletetrailerfromcontent: 'content/previews',
    listAllAwards: "awards",
    listAwardsCategory: "awards/category",
    attachAwardOnContent: "awards/content",
    listAwardsByContent: "awards/content",
    updateAwardOnContent: "awards/content",
    detachAwardOnContent: "awards/content",
    listContentLanguages: "listcontentlanguage",
    createContentLanguage: "newcontentlanguage",
    deleteContentLangauge: "removecontetlangauge",
    listcountriesforcontent: "countries",
    addcountrytocontent: "addcountrytocontent",
    removecontryfromcontent: "removecontryfromcontent",
    deleteGender: "genres/organization",
    editgenre: "editgenre",
    edittagname: "tags",
    deletetag: "tags",
    contentByTag: "content/tags",
    contentByGenre: "content/genres/by-content",
    updateVideoContent: "content/videos",
    setbypass: "setbypass",
    speakers: "speakers",
    organizations: "organizations",
    events: "events",
    eventSessions: "event-sessions",
    eventSpeakers: "event-speakers",
    eventSessionSpeakers: "event-session-speakers",
    eventAssets: "event-assets",
    eventDays: "event-days",
    eventHomeContent: "event-home-content",
    eventTheme: "event-theme"
  },
  organization_id: 1,
  reactQuery: {
    defaultOptions: {
      queries: {
        staleTime: 300000
      }
    },
    useAppConfig: {
      queryKey: "appData",
      staleTime: 300000,
    }
  },
  licenseKey: "a6HgCkGSKR3KafilrGEqqgQZB1BFqPV9ZPgOup9P7npAyQai",
  cognito: {
    region: "us-west-2",
    userPoolId: "us-west-2_1luufe4k7",
    clientId: "f3t6cj393p4vdcevcb8094gh",
    domain: ""
  }
}
